import { InjectionToken } from '@angular/core';

/**
 * The origin of the Feedback API host, e.g. `http://localhost:8000` locally.
 * Services append the `/api/v1/...` path themselves, so this should NOT include
 * the version prefix or a trailing slash.
 *
 * Provide it with {@link provideFeedbackApi}.
 */
export const API_BASE_URL = new InjectionToken<string>('FEEDBACK_API_BASE_URL');

/** The API path prefix shared by every endpoint (global `api` + controller `v1`). */
export const API_VERSION_PREFIX = 'api/v1';
